import { render } from "./BaselineStatsCharts.vue?vue&type=template&id=508bb7b5"
import script from "./BaselineStatsCharts.vue?vue&type=script&lang=js"
export * from "./BaselineStatsCharts.vue?vue&type=script&lang=js"

import "./BaselineStatsCharts.vue?vue&type=style&index=0&id=508bb7b5&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__